module.exports = __webpack_public_path__ + "static/media/arrow.a5af4b52.svg";